module.exports = __webpack_public_path__ + "static/img/cjfw-companyProducts3.64b23659.png";